import { BoatDetails, BoatGroup, HandicapSystem } from './features/boatList/BoatDetails';
import { v4 as uuidv4 } from 'uuid';


export const sampleBoatList: BoatDetails[] = [
  { id: '1', name: 'Boat 1', handicap: 1.023 },
  { id: '2', name: 'Boat 2', handicap: 0.987 },
  { id: '3', name: 'Boat 3', handicap: 0.999 },
  { id: '4', name: 'Boat 4', handicap: 1.001 },
  { id: '5', name: 'Boat 5', handicap: 0.900 },
];

let randomBoatCounter = 1;

export function blankBoat(): BoatDetails {
  return {
    id: uuidv4(),
    name: `New Boat ${randomBoatCounter++}`,
    handicap: 0,
  };
}

export function randomGroup(): BoatGroup {
  return {
    id: uuidv4(),
    name: 'New Group',
    handicapSystem: HandicapSystem.TCF,
    baseBoatId: '',
    boatDetails: [],
  };
}
